import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';


class InsertFile extends React.Component {

    constructor() {
        super();

        this.handleChange = this.handleChange.bind(this);
        this.insertContent = this.insertContent.bind(this);
        this.uploadArquivo = this.uploadArquivo.bind(this);
        this.onSelectFile = this.onSelectFile.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            titulo: '',
            descricao: '',
            uri: ''
        }

    }

    handleChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value })
    }

    insertContent({ titulo, descricao, uri }) {
        this.props.insert({ titulo, descricao, uri, tipo: 5 })
    }

    uploadArquivo() {
        this.setState({ isLoadingUpload: true })
        console.log('props->>>', this.props.match.params)
        const { numEdicao, periodico } = this.props.match.params,
            formData = new FormData();

        formData.append("fileUpload", this.state.fileUpload);
        formData.append("titulo", this.state.titulo);
        formData.append("descricao", this.state.descricao);
        formData.append("tipo", 4);

        axios.post(this.Configurations.apiBasePath + `/v2/conteudo/${periodico.toUpperCase()}/edicao/${numEdicao}/upload/arquivo`, formData, {
            headers: {
                "Content-Type": `multipart/form-data`,
            }
        }).then(response => {
            console.log("🚀 ~ InsertPDF ~ axios.post ~ response:", response)
            this.insertContent({ titulo: this.state.titulo, descricao: this.state.descricao, uri: response.data.urlPublica })
        }).catch(err => console.log(err)).finally(() => this.setState({ isLoadingUpload: false }));
    }

    onSelectFile(e) {
        this.setState({ fileUpload: e.target.files[0] })
    };

    render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
                <ModalHeader toggle={this.props.toggle}>
                    Incluir Arquivo
                </ModalHeader>
                <ModalBody>
                    <div className='row'>
                        <div className='col-12 pb-2'>
                            <label>Título</label>
                            <input name="titulo" type="text" className="form-control" onChange={this.handleChange} autoComplete="off" value={this.state.titulo} />
                        </div>
                        <div className='col-12'>
                            <label>Descrição</label>
                            <input name="descricao" type="text" className="form-control" onChange={this.handleChange} autoComplete="off" value={this.state.descricao} />
                        </div>
                        <div className="col-12 col-lg-12 text-center text-lg-left py-2 px-3 d-align-items-center d-lg-block d-none">
                            <div className="row py-3">
                                <div className="col-12">
                                    <input type="file" accept=".pdf,.ppt,.pptx" className="input-arquivo b" onChange={this.onSelectFile} />
                                    {this.state.isLoadingUpload && (
                                        <div className="spinner-border text-primary" role="status" />
                                    )}
                                </div>
                            </div>
                        </div>
                        {this.props.loading ? (
                            <div className="col-12 text-right pt-2">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        ) : (
                            <div className='col-12 text-right pt-2'>
                                <button className='btn btn-outline-success' onClick={this.uploadArquivo} disabled={!this.state.titulo || !this.state.descricao || !this.state.fileUpload}>Incluir</button>
                            </div>
                        )}

                    </div>

                </ModalBody>
            </Modal>
        );
    }
}

export default InsertFile;